import type { ReactNode } from 'react';
import { Spinner } from '../spinner/spinner.js';
import styles from './button.module.css';

type ButtonVariant = 'primary' | 'secondary' | 'secondaryDanger' | 'danger';

type ButtonProps = {
  children: ReactNode;
  variant?: ButtonVariant;
  type?: 'button' | 'submit';
  disabled?: boolean;
  busy?: boolean;
  onClick?: () => void;
};

export const Button = ({
  children,
  variant = 'primary',
  type = 'button',
  disabled = false,
  busy = false,
  onClick,
}: ButtonProps) => (
  <button
    type={type}
    className={`${styles.button} ${styles[variant]}`}
    disabled={disabled || busy}
    aria-busy={busy}
    onClick={onClick}
  >
    {busy && <Spinner size="small" />}
    {children}
  </button>
);
